function isObviouslyUnsafeUrl(value: string): boolean {
  const v = value.trim();
  if (!v) return true;
  if (/^(javascript|data|vbscript):/i.test(v)) return true;
  if (v.startsWith('//')) return true;
  if (v.startsWith('/\\')) return true;

  return false;
}

export function getReturnUrlFromQuery(search: string = window.location.search): string | undefined {
  const qs = new URLSearchParams(search);
  const raw = qs.get('returnUrl') ?? qs.get('ReturnUrl') ?? undefined;
  if (!raw) return undefined;

  return isObviouslyUnsafeUrl(raw) ? undefined : raw.trim();
}

export function getQueryParam(name: string): string | null {
  const qs = new URLSearchParams(window.location.search);
  const target = name.toLowerCase();

  const raw =
    qs.get(name) ??
    (() => {
      for (const [k, v] of qs) if (k.toLowerCase() === target) return v;
      return null;
    })();

  if (!raw) return null;

  const trimmed = raw.trim();
  if (!trimmed) return null;

  if (target === 'returnurl') {
    return isObviouslyUnsafeUrl(trimmed) ? null : trimmed;
  }

  return trimmed;
}

export function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function isOidcReturnUrl(url?: string | null): boolean {
  if (!url) return false;

  const decoded = safeDecode(url);

  return decoded.startsWith('/connect/authorize');
}

export function getConfirmAccountSuccessHref(returnUrl: string, loginRoute: string): string {
  if (!returnUrl) {
    return loginRoute;
  }

  if (isOidcReturnUrl(returnUrl)) {
    return `${loginRoute}?returnUrl=${encodeURIComponent(returnUrl)}`;
  }

  return returnUrl;
}
